import { CSSObject, Group, Stack, TextInput } from '@mantine/core';
import { textVariants } from '@ui/tokens/typography/typography';
import EmailChip from './EmailChip';
import useEmailChipsInput from './useEmailChipsInput';

const TEXT_INPUT_STYLES = {
	input: {
		'height': '30px',
		...textVariants.footnote,
		'&::placeholder': {
			color: 'var(--mantine-color-dark-2)'
		}
	} as CSSObject
};

type EmailChipsInputProps = {
	emails: string[];
	onEmailsChange: ( emails: string[] ) => void;
	emailValidator?: ( email: string ) => boolean;
	placeholder?: string;
	disabled?: boolean;
};

const EmailChipsInput = ( {
	emails,
	onEmailsChange,
	emailValidator = () => true,
	placeholder = 'Enter Email',
	disabled = false
}: EmailChipsInputProps ) => {
	const {
		inputValue,
		onKeyDown,
		onInputChange,
		onDeleteClick,
		onPaste,
		onBlur
	} = useEmailChipsInput( { emails, onEmailsChange } );

	const hasEmails = emails.length > 0;

	return (
		<Stack spacing={0} style={{ flex: '1 1 0', minWidth: 0 }} w="100%">
			{hasEmails && (
				<Group spacing={8} miw={0}>
					{emails.map( email => (
						<EmailChip
							key={email}
							email={email}
							isValid={emailValidator( email )}
							onDeleteClick={onDeleteClick}
						/>
					) )}
				</Group>
			)}
			<TextInput
				placeholder={emails.length === 0 ? placeholder : ''}
				variant="unstyled"
				styles={TEXT_INPUT_STYLES}
				value={inputValue}
				onChange={onInputChange}
				onKeyDown={onKeyDown}
				onPaste={onPaste}
				onBlur={onBlur}
				disabled={disabled}
				w="100%"
			/>
		</Stack>
	);
};

export default EmailChipsInput;
